import styled from "styled-components";

const Arrow = styled.button`
    background: #FF5701;
    border-radius: 100%;
    color: #fff;
    box-shadow: 1px 1px 1px rgba(0, 0, 0, 0.3);
    display: flex;
    justify-content: center;
    align-items: center;
    height: 45px;
    width: 45px;
    font-size: 40px;
`;

export default Arrow;
